import { render, staticRenderFns } from "./ChildLayout.vue?vue&type=template&id=4f6be830&scoped=true&"
import script from "./ChildLayout.vue?vue&type=script&lang=js&"
export * from "./ChildLayout.vue?vue&type=script&lang=js&"
import style0 from "./ChildLayout.vue?vue&type=style&index=0&id=4f6be830&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6be830",
  null
  
)

export default component.exports